import { fetchService } from "./fetchService";
import { MonthlyData } from "../pages/cost-dashboard/types";

export interface AvailableMonthsResponse {
  months: string[];
}

export async function getAvailableMonths(): Promise<AvailableMonthsResponse> {
  return fetchService<AvailableMonthsResponse>("exec-report/months");
}

export async function getMonthDashboard(month: string, platform: string): Promise<MonthlyData> {
  return fetchService<MonthlyData>(`exec-report/${encodeURIComponent(platform)}/${encodeURIComponent(month)}/dashboard`);
}
